/* eslint-disable @typescript-eslint/camelcase */
import { takeLatest, put, call } from "redux-saga/effects";
import * as types from "src/types/actions";
import callApi from "./helpers";
import { apiAuthURI } from "src/env";

const getConfig = (params) => {
  return {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(params),
  };
};

const submitLogin = ({
  apiAuthURI,
  raNumber,
  dob,
  lastName,
  pickupDate,
  pickupLoc,
  country,
  driverLicenseNumber,
}) => {
  const params = raNumber
    ? {
        ra_number: raNumber,
        dob,
      }
    : {
        ra_number: "",
        license_number: driverLicenseNumber,
        last_name: lastName,
        pickup_loc: pickupLoc,
        pickup_date: pickupDate,
        country: country,
      };
  console.log("pram", params);
  return fetch(apiAuthURI, getConfig(params));
};

const submitCorporateLogin = ({ apiAuthURI, raNumber, lastName, cdp }) => {
  // If length of "cdp" field is > 4 then it's a CDP login attempt
  const params =
    cdp.length > 4
      ? {
          ra_number: raNumber,
          last_name: lastName,
          cdp,
        }
      : {
          ra_number: raNumber,
          last_name: lastName,
          cc_last_digits: cdp,
        };

  return fetch(apiAuthURI, getConfig(params));
};

export function* login(params) {
  try {
    console.log("params", params);
    yield call(
      callApi,
      params.payload.corporate
        ? () => submitCorporateLogin({ apiAuthURI, ...params.payload.values })
        : () => submitLogin({ apiAuthURI, ...params.payload.values }),
      types.LOGIN
    );
  } catch (error) {
    yield put({ type: types.LOGIN_FAILURE, error: error });
  }
}

export function* watchAuthRequest() {
  [yield takeLatest(types.LOGIN, login)];
}
